import { FormExtractorService } from '../../../shared/services/form-extractor.service';
import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_28_2 implements Validator {

    public static id = 'CTRL_28_2';
    private message = 'error.ctr_28';


    public LOG: LogService = new LogService(CTRL_28_2);
    public formExtractorService: FormExtractorService = new FormExtractorService();

    
    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_28_2.id + '_');

        if (rgs.length > 0) {
            for (const rg of rgs) {
                const ctrl = form.controls[rg];
                const critere = ctrl.value.rgCtrls.critere;
                const criterePoids = ctrl.value.rgCtrls.criterePoids;

                const controls = this.formExtractorService.getMapControlsIdWithoutStepAndValue(form);
                const criterePondereIters = this.formExtractorService.getIndexes(Array.from(controls.keys()), ['_SepSep_CriterePondere'], '_index_');
                if (criterePondereIters.size < 2 ) {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                } else {
                    let nbCriterePondere = 0;
                    for (let i = 1; i <= criterePondereIters.size; i++) {
                        const critereCtrl = form.controls[map.get(critere.replace('INDEX_28_1', i))];
                        const criterePoidsCtrl = form.controls[map.get(criterePoids.replace('INDEX_28_1', i))];
                        if (critereCtrl.value !== '' && criterePoidsCtrl.value !== '') {
                            nbCriterePondere++;
                        }
                    }
                    if (nbCriterePondere > 1) {
                        form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                    } else {
                        // placer le message d'erreur
                        form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                    }
                }
            }
        }
    }
}
